export default __webpack_public_path__ + "static/media/Share_Icon.908a8c81.svg";